import React from "react";
import styles from './form.module.css'

const variantStyles = {
    primary: styles.primary,
    secondary: styles.secondary,
    accent: styles.accent,
    info: styles.info,
    success: styles.success,
    danger: styles.danger,
    neutral: styles.neutral,
    plain: styles.plain,
}

const sizeStyles = {
    sm: styles.buttonSm,
    md: "",
    lg: styles.buttonLg,
}

const Button = ({ className = "", variant = "primary", size = "md", fullWidth = true, type, disabled, onClick, children, ...props }) => {
    const variantClass = variantStyles[variant] || variantStyles.primary
    const sizeClass = sizeStyles[size] || ""

    return (
        <button
            type={type}
            className={`${styles.button} ${variantClass} ${sizeClass} ${fullWidth ? styles.fullWidthButton : styles.fitWidthButton} ${className}`.trim()}
            onClick={onClick}
            disabled={disabled}
            {...props}
        >
            {children}
        </button>
    )
}

export default Button
